import { create } from "zustand";

const folderStore = (set) => ({
  folders: [],
  setFolders: (newError) => set({ folders: newError }),
});

export const useFolderStore = create(folderStore);
